import cx from 'clsx'
import React from 'react'

export default function Container({ className, ...props }: any) {
	return <div className={cx('fade-in h-full w-full', className)} {...props} />
}
